export default __webpack_public_path__ + "static/media/TWITTER_icon.24553b63.svg";